import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import strings from '../../locale/en'
import { getQrCodeList, manageQrCode } from './api'
import { QrCodeInfo, QrCodeSelection } from './typings'

const initialState = {
  content: [],
  totalPages: 0,
  number: 0,
  isLoading: false,
  error: ''
}

export const qrCodeSlice = createSlice({
  name: 'qrCode',
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = ''
    },
    selectQrCode: (state, action: PayloadAction<QrCodeSelection>) => {
      const qrList: any = state.content.map((qrcode: QrCodeInfo) => ({
        ...qrcode,
        isSelected:
          qrcode.id === action?.payload?.id
            ? !qrcode.isSelected 
            : qrcode.isSelected
      }))
      state.content = qrList
    },
    selectAllQrCode: (state) => {
      const qrList: any = state.content.map((qrcode: QrCodeInfo) => ({
        ...qrcode,
        isSelected: true
      }))
      state.content = qrList
    },
    deSelectAllQrCode: (state) => {
      const qrList: any = state.content.map((qrcode: QrCodeInfo) => ({
        ...qrcode,
        isSelected: false
      }))
      state.content = qrList
    }
  },
  extraReducers: {
    [getQrCodeList.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getQrCodeList.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      state.content = action?.payload?.content
      state.number = action?.payload?.number
      state.totalPages = action?.payload?.totalPages
    },
    [getQrCodeList.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [manageQrCode.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = strings.error.unableToAssignQrCode
    }
  }
})

export default qrCodeSlice.reducer
